<template>
	<CardGrafico
		:title="`${chartScopes.find((f) => f.value === dropdownTipoGrafico).label} por faixa de idade`"
		:subtitle="updatedAt"
	>
		<template #botoes>
			<ButtonDropdown
				v-show="!curvas.length"
				v-model="dropdownTipoGrafico"
				class="tamanhoButton"
				label="VTCC"
				color="trv-default"
				semantic-class="mini"
				:options="chartScopes"
				outlined
			/>
		</template>
		<template #grafico>
			<div
				v-if="series.length === 0"
				class="divTexto"
			>
				<p
					v-if="mostrarTexto == 'true'"
					class="textoinformativo"
				/>
				<p
					v-else
					class="textoinformativo"
				>
					{{ $t('selecioneOsFiltros') }}
				</p>
			</div>

			<div
				v-else
				class="container__grafico__dispersao"
			>
				<slot name="action-buttons" />
				<Chart
					id="dispersao__parcelas"
					ref="ref__chart"
					:options="chartOptions"
				/>
			</div>
		</template>
	</CardGrafico>
</template>

<script>
import { Chart } from 'highcharts-vue'
import ButtonDropdown from '../../components/ButtonDropdown/ButtonDropdown'
import CardGrafico from '../CardGrafico/CardGrafico'

// import _ from "lodash";

import { stringToExportCSV } from '../../utils/csvHellpers'

export default {
	components: { ButtonDropdown, CardGrafico, Chart },
	props: {
		/**
		 * Dados que devem ir para o grafico
		 */
		maximoVariavel: { type: Number },
		mostrarTexto: { type: String },
		selectOnZoom: { type: Boolean, default: false },
		idadeReferencia: { type: Number, default: 0 },
		tipo: { type: String },
		series: { type: Array, required: true },
		curvas: {
			type: Array,
			default: () => {
				return []
			},
		},
		updatedAt: { type: String, required: false, default: '' },
		options: {
			type: Array,
			required: false,
			default: () => {
				return []
			},
		},
	},
	data() {
		return {
			redraw: true,
			dropdownTipoGrafico: this.tipo ? this.tipo : 'alturaDominante',
			dropdownDownload: '',
			parcelasTemporarias: [],
			chartScopes: this.options.length
				? this.options
				: [
						{
							label: 'Altura Dominante',
							value: 'alturaDominante',
							acronimo: 'H_DOM',
							latex: 'HDom',
							unidade: '(m)',
						},
						{
							label: 'DAP Máximo',
							value: 'dapMaximo',
							acronimo: 'DAP_MAX',
							latex: 'Dap_{max}',
							unidade: '(cm)',
						},
						{
							label: this.$t('volumeIndividualComCasca'),
							value: 'volumeIndividualComCasca',
							acronimo: 'VICC',
							latex: 'VICC',
							unidade: '(m^3/fuste)',
						},
						{
							label: this.$t('diametroMedioQuadratico'),
							value: 'diametroMedioQuadratico',
							acronimo: 'DG',
							latex: 'DG',
							unidade: '(cm)',
						},
						// {
						//   label: "Incremento Médio Anual do VTCC",
						//   value: "incrementoMedioAnualComCasca",
						//   acronimo: "IMA_VTCC",
						//   latex: "IMA_{VTCC}",
						//   unidade: "(m^3/ha/ano)",
						// },
						{
							label: 'VTCC',
							value: 'volumeTotalComCasca',
							acronimo: 'VTCC',
							latex: 'VTCC',
							unidade: '(m^3/ha)',
						},
						{
							label: 'Área Basal',
							value: 'areaBasal',
							acronimo: 'AB',
							latex: 'AB',
							unidade: '(m^2/ha)',
						},
					],
		}
	},

	computed: {
		selectedPoints() {
			return this.$refs.ref__chart.chart //.getSelectedPoints();
		},

		/**
		 * Options para configuracao do grafico
		 */

		chartOptions() {
			let variavel = this.chartScopes.find((f) => f.value === this.dropdownTipoGrafico)
			let titulo = `${variavel.label} ${variavel.unidade}`

			return {
				chart: {
					type: 'scatter',
					zoomType: 'xy',
					events: {
						selection: (e) => {
							console.log(e)
							if (!e.resetSelection) {
								this.parcelasTemporarias.length = 0

								this.dadosSeries.forEach((dataSerie) => {
									this.parcelasTemporarias.push(
										...dataSerie.data.filter(
											(point) =>
												point[0] >= e.xAxis[0].min &&
												point[0] <= e.xAxis[0].max &&
												point[1] >= e.yAxis[0].min &&
												point[1] <= e.yAxis[0].max,
										),
									)
								})
								this.$emit('selectedPoints', this.parcelasTemporarias)
								return true // Don't zoom
							} else {
								this.$emit('selectedPoints', [])
							}
						},
					},
					// redraw: true
				},
				boost: {
					useGPUTranslations: true,
					usePreAllocated: true,
				},
				title: {
					text: '',
				},

				subtitle: {
					text: '',
				},
				xAxis: {
					min: 0,
					title: {
						enabled: true,
						text: 'Idade (meses) ',
						style: {
							fontSize: '100%',
						},
					},
					plotLines: [
						this.idadeReferencia ? { color: 'red', width: 2, value: this.idadeReferencia } : {},
					],
					startOnTick: true,
					endOnTick: true,
					showLastLabel: true,
				},
				yAxis: {
					min: 0,
					max: this.curvas.length ? this.maximoVariavel * 1.1 : undefined,
					title: {
						text: titulo,
						style: {
							fontSize: '100%',
						},
					},

					legend: {
						enabled: true,
					},
				},
				legend: {
					layout: 'vertical',
					align: 'left',
					verticalAlign: 'top',
					x: 100,
					y: 70,
					floating: true,
					enabled: false,
					borderWidth: 1,
				},
				plotOptions: {
					spline: {
						marker: { enabled: false },
						states: { hover: { enabled: true } },
					},
					scatter: {
						marker: {
							radius: 5,
							states: {
								hover: {
									enabled: true,
									lineColor: 'rgb(100,100,100)',
								},
							},
						},
						states: {
							hover: {
								marker: {
									enabled: true,
								},
							},
						},
						tooltip: {
							positioner: function () {
								return { x: 40, y: 25 }
							},
							headerFormat: '<b>{point.id}</b><br>',
							pointFormat:
								'Idade: {point.x:.0f} meses<br>' +
								this.chartScopes.find((f) => f.value === this.dropdownTipoGrafico).label +
								': {point.y:.3f} ' +
								this.chartScopes
									.find((f) => f.value === this.dropdownTipoGrafico)
									.unidade.replace('(', '')
									.replace(')', ''),
						},
					},
					series: {
						allowPointSelect: true,
						point: {
							events: {
								click: function (e) {
									e.point.select(true, true)
								},
								select: () => {
									this.$emit('selectedPoints', this.$refs.ref__chart.chart.getSelectedPoints())
								},
								mouseOver: function () {
									if (this.series.halo) {
										this.series.halo
											.attr({
												class: 'highcharts-tracker',
											})
											.toFront()
									}
								},
							},
						},
					},
				},

				series: this.dadosSeries,
			}
		},

		/**
		 * Prepara os dados de parcelas (Inventário tradicional) para serem plotadas no grafico de dispersão
		 */
		dadosParcelas() {
			// let dado = this.series.filter(el => !el.isSingleTrees).map(e => { return  { x: Number(e.idade.toFixed(3)), y: e[this.dropdownTipoGrafico], id: e.id + "-" + this.series.indexOf(e), idAgrupamento: e.id }})
			let dado = this.series
				.filter((el) => !el.isSingleTrees)
				.map((e) => {
					return [Number(e.idade), e[this.dropdownTipoGrafico]]
				})

			return dado
		},

		/**
		 * Prepara os dados de plantios (Single Trees) para serem plotadas no grafico de dispersão
		 */
		dadosPlantios() {
			let dado = this.series
				.filter((el) => el.isSingleTrees)
				.map((e) => {
					return [Number(e.idade), e[this.dropdownTipoGrafico]]
				})

			return dado
		},

		dadosSeries() {
			let series = [...this.curvas]

			if (this.dadosParcelas.length)
				series.push({
					name: 'Parcela',
					color: `rgb(149, 187, 73)`,
					data: this.dadosParcelas,
					turboThreshold: Number.MAX_SAFE_INTEGER,
					boostThreshold: 2000,
					animation: false,
					marker: {
						symbol: 'circle',
					},
				})

			if (this.dadosPlantios.length)
				series.push({
					name: 'Plantio',
					color: `rgb(1, 57, 94)`,
					data: this.dadosPlantios,
					boostThreshold: 2000,
					turboThreshold: Number.MAX_SAFE_INTEGER,
					animation: false,
					marker: {
						symbol: 'circle',
					},
				})

			return series
		},

		/**
		 * Configuracao do grafico de acordo com o tipo exibido
		 */
		// configuracaoDoGrafico() {
		//   if (this.dropdownTipoGrafico === "volumeTotalComCasca") {
		//     return {
		//       tipoDoGrafico: "Volume Total com Casca (m³/ha)",
		//       titulo: "Volume Total com Casca por faixa de idade",
		//       posicaoDataLabel: -35,
		//     };
		//   } else if (this.dropdownTipoGrafico === "dapMaximo") {
		//     return {
		//       tipoDoGrafico: "DAP Máximo (cm)",
		//       titulo: "DAP Máximo por faixa de idade",
		//       posicaoDataLabel: -35,
		//     };
		//   } else if (this.dropdownTipoGrafico === "alturaDominante") {
		//     return {
		//       tipoDoGrafico: "Altura Dominante (m)",
		//       titulo: "Altura Dominante por faixa de idade",
		//       posicaoDataLabel: -35,
		//     };
		//   } else if (this.dropdownTipoGrafico === "areaBasal") {
		//     return {
		//       tipoDoGrafico: "Área Basal (m^2/ha)",
		//       titulo: "Área Basal por faixa de idade",
		//       posicaoDataLabel: -35,
		//     };
		//   } else if (this.dropdownTipoGrafico === "volumeIndividualComCasca") {
		//     return {
		//       tipoDoGrafico: "Volume Individual com Casca (m^3/fuste)",
		//       titulo: "Volume Individual com Casca por faixa de idade",
		//       posicaoDataLabel: -35,
		//     };
		//   } else if (this.dropdownTipoGrafico === "incrementoMedioAnualVTCC") {
		//     return {
		//       tipoDoGrafico: "Incremento Médio Anual do VTCC (m^3/ha/ano)",
		//       titulo: "Incremento Médio Anual do VTCC por faixa de idade",
		//       posicaoDataLabel: -35,
		//     };
		//   } else if (this.dropdownTipoGrafico === "proporcaoDeFustes") {
		//     return {
		//       tipoDoGrafico: "Proporção de Fustes Úteis (%)",
		//       titulo: "Proporção de Fustes Úteis por faixa de idade",
		//       posicaoDataLabel: -35,
		//     };
		//   } else if (this.dropdownTipoGrafico === "volumeTotalSemCasca") {
		//     return {
		//       tipoDoGrafico: "Volume Total sem Casca (m³/ha)",
		//       titulo: "Volume Total sem Casca por faixa de idade",
		//       posicaoDataLabel: -35,
		//     };
		//   } else if (this.dropdownTipoGrafico === "incrementoMedioAnualSemCasca") {
		//     return {
		//       tipoDoGrafico: "Incremento médio anual sem casca (m³/ha/ano)",
		//       titulo: "Incremento médio anual sem casca por faixa de idade",
		//       posicaoDataLabel: -35,
		//     };
		//   } else if (this.dropdownTipoGrafico === "dapMedio") {
		//     return {
		//       tipoDoGrafico: "DAP Médio (cm)",
		//       titulo: "DAP Médio por faixa de idade",
		//       posicaoDataLabel: -35,
		//     };
		//   } else if (this.dropdownTipoGrafico === "dapMinimo") {
		//     return {
		//       tipoDoGrafico: "DAP Mínimo (cm)",
		//       titulo: "DAP Mínimo por faixa de idade",
		//       posicaoDataLabel: -35,
		//     };
		//   } else if (this.dropdownTipoGrafico === "alturaTotalMaxima") {
		//     return {
		//       tipoDoGrafico: "Altura total máxima (m)",
		//       titulo: "Altura total máxima por faixa de idade",
		//       posicaoDataLabel: -35,
		//     };
		//   } else {
		//     return {
		//       tipoDoGrafico: "Diâmetro Médio Quadrático (cm)",
		//       titulo: "Diâmetro Médio Quadrático por faixa de idade",
		//       posicaoDataLabel: -55,
		//     };
		//   }
		// },
	},
	watch: {
		selectOnZoom(e) {
			if (!e)
				this.$refs.ref__chart.chart.eventOptions.selection = function () {
					return true
				}
		},

		/**
		 * Tipo do grafico que deve ser mostrado
		 * Área Plantada, Volume ou IMA
		 */
		dropdownTipoGrafico() {
			// this.changeHighchartsOptions();
			this.$emit(
				'tipoGrafico',
				this.chartScopes.find((m) => m.value == this.dropdownTipoGrafico),
			)
		},
		/**
		 * Seleciona a opcao de download escolhida
		 */
		dropdownDownload(type) {
			if (type) {
				const filename = `${new Date().getTime()}`
				if (type === 'text/csv') {
					const csv = this.$refs.ref__chart.chart.getCSV()
					stringToExportCSV(filename, csv)
				} else {
					this.$refs.ref__chart.chart.exportChart({ filename, type })
				}
				this.dropdownDownload = ''
			}
		},
	},
	mounted() {
		// const rgbDefaultColor = getComputedStyle(document.body).getPropertyValue(
		//   "--color-default"
		// );
		// this.chartOptions.series[0].color = `rgb(${rgbDefaultColor})`;

		this.$emit(
			'tipoGrafico',
			this.chartScopes.find((m) => m.value == this.dropdownTipoGrafico),
		)
	},

	methods: {},
}
</script>

<style scoped>
/* @import url("../../css/tooltipSimplesHighcharts.css"); */
.container__grafico__dispersao {
	display: block;
	flex-direction: column;
	height: 100%;
}

.highcharts-container {
	margin: 0 !important;
	height: 100% !important;
}
.textoinformativo {
	color: rgb(149, 187, 73);
	text-align: center;
	vertical-align: bottom;
	font-weight: 800;
}
.tamanhoButton {
	width: 210px;
}
.divTexto {
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
}
#dispersao__parcelas {
	height: 100%;
	max-height: 90%;
}
</style>
